import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import HomePage from './pages/HomePage';
import AnalyzeUrlPage from './pages/AnalyzeUrlPage';
import AnalyzeHubPage from './pages/AnalyzeHubPage';
import AnalyzeMessagePage from './pages/AnalyzeMessagePage';
import AnalyzeQrPage from './pages/AnalyzeQrPage';
import ResultsPage from './pages/ResultsPage';
import HistoryPage from './pages/HistoryPage';
import ReportsPage from './pages/ReportsPage';
import SignalementsPage from './pages/SignalementsPage';
import ReportPage from './pages/ReportPage';
import HowItWorksPage from './pages/HowItWorksPage';
import ProfilePage from './pages/ProfilePage';
import OnboardingPage from './pages/OnboardingPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import Footer from './components/layout/Footer';
import { AuthProvider, useAuth } from './components/auth/AuthContext';
import ChatbotWidget from './components/chat/ChatbotWidget';

function RequireAuth({ children }) {
  const { isAuthenticated, hasSeenOnboarding } = useAuth();
  const location = useLocation();
  if (!hasSeenOnboarding) return <Navigate to="/onboarding" replace />;
  if (!isAuthenticated) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  return children;
}

function PublicOnly({ children }) {
  const { isAuthenticated, hasSeenOnboarding } = useAuth();
  const { pathname } = useLocation();
  if (!hasSeenOnboarding && pathname !== '/onboarding') return <Navigate to="/onboarding" replace />;
  if (isAuthenticated) return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  const { isAuthenticated } = useAuth();
  const { pathname } = useLocation();
  const publicRoutes = ['/onboarding', '/login', '/register'];
  const showFooter = isAuthenticated && !publicRoutes.includes(pathname);

  return (
    <div className="app-shell">
      <Routes>
        <Route path="/onboarding" element={<PublicOnly><OnboardingPage /></PublicOnly>} />
        <Route path="/login" element={<PublicOnly><LoginPage /></PublicOnly>} />
        <Route path="/register" element={<PublicOnly><RegisterPage /></PublicOnly>} />
        <Route path="/" element={<RequireAuth><HomePage /></RequireAuth>} />
        <Route path="/analyze" element={<RequireAuth><AnalyzeHubPage /></RequireAuth>} />
        <Route path="/analyze/url" element={<RequireAuth><AnalyzeUrlPage /></RequireAuth>} />
        <Route path="/analyze/message" element={<RequireAuth><AnalyzeMessagePage /></RequireAuth>} />
        <Route path="/analyze/qr" element={<RequireAuth><AnalyzeQrPage /></RequireAuth>} />
        <Route path="/results" element={<RequireAuth><ResultsPage /></RequireAuth>} />
        <Route path="/history" element={<RequireAuth><HistoryPage /></RequireAuth>} />
        <Route path="/reports" element={<RequireAuth><ReportsPage /></RequireAuth>} />
        <Route path="/signalements" element={<RequireAuth><SignalementsPage /></RequireAuth>} />
        <Route path="/report" element={<RequireAuth><ReportPage /></RequireAuth>} />
        <Route path="/how-it-works" element={<RequireAuth><HowItWorksPage /></RequireAuth>} />
        <Route path="/profil" element={<RequireAuth><ProfilePage /></RequireAuth>} />
        <Route path="*" element={<Navigate to={isAuthenticated ? '/' : '/onboarding'} replace />} />
      </Routes>
      {showFooter ? <Footer /> : null}
      <ChatbotWidget />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
